import {Link} from "react-router-dom";
import {REACT_APP_VERSION} from "../../utils/constants";
import {Typography} from "@mui/material";

export default function Copyright(props) {
    return (
        <Typography
            {...props}
            variant="body2"
            style={{fontSize:"12px", color:"rgba(255, 255, 255, 0.7)"}}
        >
            {'Copyright © '}{new Date().getFullYear()}{' '}<br></br>
            <Link to={{pathname:`https://www.alosys.it`}} target="_blank">Alosys Communications</Link>
            {' '}
            {'.'} <br/>
            v{REACT_APP_VERSION}
        </Typography>

    );
}